"use strict";

var calendarWidget = function () {
  var today = new Date();
  var viewedDay = null;
  var viewedEvent = null;
  var isDateChangeAccepted = false;
  var selectedDate = null;
  var descisionObject = {
    Action: 'New',
    VariantId: '',
    EventId: null
  };
  var calendarWidgetParams = {
    model: {
      isInited: false
    },
    url: {},
    template: {}
  };

  function renderDecisionPane(options) {
    var $modalFooter = $('.modal-footer');
    $modalFooter.empty();
    $modalFooter.removeClass('-sm-padded -normal-padded');

    if (options.type === 'pane') {
      var status = descisionObject.Action;

      if (options.pane.text == 'Приглашение не принято' || options.pane.text == 'Выберите другую дату и время') {
        status = 'Rejected';
      }

      var $pane = $("<div class=\"pane -wide\">\n                    <span class =\"event-invitation-status ".concat(status, "\">").concat(options.pane.text, "</span>\n                </div>"));

      if (options.pane.action) {
        $pane.append("<span class=\"link event-invitation-action text-xs\">".concat(options.pane.action.title, "</span>"));
      }

      $modalFooter.append($pane);
      $modalFooter.addClass('-sm-padded');
    }

    if (options.type === 'buttons') {
      var buttons = '';
      options.buttons.forEach(function (btn) {
        buttons += "<button class=\"btn ".concat(btn.classes, "\">").concat(btn.title, "</button>");
      });
      $modalFooter.append($(buttons));
      $modalFooter.addClass('-normal-padded');
    }

    $modalFooter.show();
  }

  function configDecisionPane(event) {
    var paneOptions = {};

    if (event.type === 'Meeting') {
      if (!event.isPast) {
        if (event.status === 'Accepted' || event.status === 'AcceptedAlter') {
          paneOptions = {
            type: 'pane',
            pane: {
              text: 'Приглашение принято',
              action: {
                title: 'Изменить решение'
              }
            }
          };
        } else if (event.status === 'New') {
          if (event.date > today || selectedDate != null) {
            paneOptions = {
              type: 'buttons',
              buttons: [{
                title: 'Принять',
                classes: '-primary -big -wide event-invitation-accepted'
              }, {
                title: 'Отклонить',
                classes: '-secondary -big -wide event-invitation-rejected'
              }]
            };
          } else {
            paneOptions = {
              type: 'pane',
              pane: {
                text: 'Выберите другую дату и время'
              }
            };
          }
        } else {
          paneOptions = {
            type: 'pane',
            pane: {
              text: 'Приглашение отклонено',
              action: {
                title: 'Изменить решение'
              }
            }
          };
        }
      } else {
        if (event.status === 'New') {
          paneOptions = {
            type: 'pane',
            pane: {
              text: 'Приглашение не принято'
            }
          };
        } else if (event.status === 'Accepted' || event.status === 'AcceptedAlter') {
          paneOptions = {
            type: 'pane',
            pane: {
              text: 'Приглашение принято'
            }
          };
        } else {
          paneOptions = {
            type: 'pane',
            pane: {
              text: 'Приглашение отклонено'
            }
          };
        }
      }

      renderDecisionPane(paneOptions);
    }
  }

  function getDayEvents(data, callback) {
    $.ajax({
      url: calendarWidgetParams.url.getDayEvents,
      type: 'POST',
      data: data,
      success: function success(template) {
        callback(template);
      }
    });
  }

  function getEventCard(data, callback) {
    $.ajax({
      url: "".concat(calendarWidgetParams.url.getEventCard, "/").concat(data.type, "/").concat(data.id),
      type: 'GET',
      success: function success(template) {
        callback(template);
      }
    });
  }

  function confirmDescision(data, callback) {
    data = descisionObject;
    $.ajax({
      url: calendarWidgetParams.url.confirmAction,
      type: 'POST',
      data: data,
      success: function success(resp) {
        callback(resp);
      }
    });
  }

  function renderAgenda() {
    var $scheduler = $('#scheduler').data('kendoScheduler');

    if ($(window).width() <= 768) {
      $scheduler.view('customAgenda');
    } else {
      $scheduler.view('month');
    }
  }

  function getMonth(date) {
    return "0".concat(date.getMonth() + 1).slice(-2);
  }

  function getDate(date) {
    return "0".concat(date.getDate()).slice(-2);
  }

  function renderEvent(event) {
    var eventTemplate = "<tr role=\"row\" aria-selected=\"false\"\n                class =\"event ".concat(event.start < today ? '-paste' : '-coming', " ").concat(event.EventType, "\n                        ").concat(event.MeetingState ? "-".concat(event.MeetingState) : '', "\">\n                <td class =\"k-scheduler-datecolumn k-first event-datetime\" rowspan=\"1\">\n                    <div class =\"k-scheduler-agendadate\">").concat(getDate(event.start), ".").concat(getMonth(event.start), ".").concat(event.start.getFullYear(), "</div>\n                    <div class =\"k-scheduler-timecolumn\">").concat(event.EventDate.split('-').join(' - '), "</div>\n                </td>\n                <td class =\"k-scheduler-event\" >\n                    <div class =\"k-task\" title=\"").concat(event.title, "\" data-uid=\"").concat(event.uid, "\">\n                        <div title='").concat(event.title, "'\n                             data-evt-type='").concat(event.EventType, "'\n                             class ='eventItem ").concat(event.EventType, " light'>").concat(event.title, "</div>");

    if (event.EventType !== 'Occupation' || event.ObjectInfo != null) {
      eventTemplate = eventTemplate + " <div class='event-obj'>".concat(event.ObjectInfo, "</div>");
    }

    eventTemplate = eventTemplate + "</div></td></tr>";
    return eventTemplate;
  }

  function renderAgendaEvents(evts) {
    var pastEvents = "";
    var comingEvents = "";
    var events = "";
    var orderedEvents = evts.sort(function (a, b) {
      if (a.start < b.start) {
        return -1;
      }

      if (a.start > b.start) {
        return 1;
      }

      return 0;
    });
    orderedEvents.forEach(function (evt) {
      var eventTemplate = renderEvent(evt);

      if (evt.start < today) {
        pastEvents += eventTemplate;
      } else {
        comingEvents += eventTemplate;
      }
    });
    events = $(comingEvents + pastEvents);
    return events;
  } //function sendDescisionData() {
  //    if (viewedEvent && viewedEvent.type === 'Meeting') {
  //        // confirm only if submited
  //        if (isDateChangeAccepted) {
  //            confirmDescision(descisionObject, function (resp) {
  //                const passed = resp.Success;
  //                if (passed) {
  //                    descisionObject = {
  //                        Action: 'New',
  //                        VariantId: '',
  //                        EventId: null,
  //                    };
  //                } else {
  //                    console.error(resp.Result);
  //                }
  //            });
  //        }
  //    }
  //    return null;
  //}


  function openDayEventsModal(date) {
    viewedDay = date; // using toISOString adds a time zone to the date, 
    // but when sent in a request С#,
    // it is set to a local time without a time zone.

    var day = {
      //Day: viewedDay.toISOString()б
      Day: viewedDay.toLocaleDateString()
    };
    modalDialog.busyIndicator(true);
    getDayEvents(day, function (template) {
      var modalContent = $('<div></div>');
      modalDialog.busyIndicator(false);
      modalContent.html(template);
      modalContent.showAsModal({
        title: "\u0421\u043E\u0431\u044B\u0442\u0438\u044F \u043D\u0430 ".concat(viewedDay.toLocaleDateString()),
        isVertical: true,
        onClose: function onClose() {
          var $scheduler = $('#scheduler').data('kendoScheduler');
          $scheduler.dataSource.read();
        },
        afterClose: function afterClose() {
          viewedDay = null;
          viewedEvent = null;
          isDateChangeAccepted = false;
          selectedDate = null;
        }
      });
    });
  }

  function setParams(calendarParams) {
    calendarWidgetParams = $.extend({}, calendarWidgetParams, calendarParams);
  }

  function unbindHandlers() {
    $(window).off('resize', renderAgenda);
    $(document).off('click', '.k-event, .k-task');
    $(document).off('click', '.event-list-item');
    $(document).off('click', '.event-list-back');
    $(document).off('click', '.event-invitation-action');
    $(document).off('click', '.event-invitation-accepted');
    $(document).off('click', '.event-invitation-rejected');
    $(document).off('change', '#Variants');
    $(document).off('mouseenter', '.eventItem');
    $(document).off('mouseleave', '.eventItem');
  }

  function openEventCard(event) {
    viewedEvent = {
      id: event.Id,
      type: event.EventType,
      status: event.MeetingState,
      date: event.start,
      isPast: event.IsPast
    };
    modalDialog.busyIndicator(true);
    getEventCard(viewedEvent, function (template) {
      var modalContent = $('<div></div>');
      modalDialog.busyIndicator(false);
      modalContent.html(template);
      modalContent.showAsModal({
        isVertical: true,
        afterOpen: function afterOpen() {
          $('.modal-body').addClass('-not-padded-top'); // set current user decision

          if (viewedEvent.type === 'Meeting') {
            descisionObject = {
              Action: viewedEvent.status,
              VariantId: $('#Variants').val() || '',
              EventId: viewedEvent.id
            };
          }

          configDecisionPane(viewedEvent); // init selectric

          LKCommon.initSelectric($('.event-details .select'));
        },
        onClose: function onClose() {
          if (viewedEvent.type === 'Meeting') {
            // confirm only if submited
            if (isDateChangeAccepted) {
              confirmDescision(descisionObject, function (resp) {
                var passed = resp.Success;
                var $scheduler = $('#scheduler').data('kendoScheduler');

                if (passed) {
                  descisionObject = {
                    Action: 'New',
                    VariantId: '',
                    EventId: null
                  };
                  $scheduler.dataSource.read();
                } else {
                  console.error(resp.Result);
                }

                return passed;
              });
            }
          }
        },
        afterClose: function afterClose() {
          viewedEvent = null;
          isDateChangeAccepted = false;
          selectedDate = null;
        }
      });
    });
  }

  function openEventCardById(id) {
    var scheduler = $('#scheduler').data('kendoScheduler');
    var view = scheduler.dataSource.view();
    var filteredEvents = $.grep(view, function (a) {
      return a.id == id;
    });

    if (filteredEvents.length) {
      scheduler.date(filteredEvents[0].start);
      openEventCard(filteredEvents[0]);
    } else {
      modalDialog.showBaseWnd({
        title: 'Ошибка',
        buttons: [{
          title: 'Хорошо',
          big: true,
          primary: true
        }],
        onDrawContent: function onDrawContent() {
          return 'Не найдено запрошенного события';
        }
      });
    }
  }

  function setParameters(id, dateStr) {
    descisionObject.VariantId = id;
    selectedDate = dateStr;
    configDecisionPane(viewedEvent);
  }

  function bindHandlers() {
    $(window).on('resize', renderAgenda);
    $(document).on('change', '#Variants', function () {
      var selectData = $(this).data('selectric');
      var selectOption = selectData.items[selectData.state.selectedIdx];
      var selectCurrentText = selectOption.text;
      $('.event-details-date-val').text(selectCurrentText);
      var date = selectCurrentText.split(',')[0];
      var time = selectCurrentText.split(',')[1].split('-')[0];
      setParameters(selectOption.value, date + ' ' + time);
    });
    $(document).on('click', '.k-event, .k-task', function (e) {
      var scheduler = $('#scheduler').data('kendoScheduler');
      var event = scheduler.dataSource.getByUid($(e.currentTarget).attr('data-uid'));
      openEventCard(event);
    });
    $(document).on('click', '.event-list-item', function () {
      var $eventListLoader = $('.event-list').find('.loader.-local');
      viewedEvent = {
        id: $(this).attr('data-id'),
        type: $(this).attr('data-evt-type'),
        status: $(this).attr('data-evt-status'),
        date: viewedDay,
        isPast: $(this).attr('data-evt-ispast')
      };
      $eventListLoader.show();
      getEventCard(viewedEvent, function (template) {
        $eventListLoader.hide();
        $('.modal-title').html("<a href=\"javascript:void(0)\" class=\"link -back event-list-back\">\u0412\u0441\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u043D\u0430 ".concat(viewedDay.toLocaleDateString(), "</a>"));
        $('.modal-body').html(template); // set current user decision

        if (viewedEvent.type === 'Meeting') {
          descisionObject = {
            Action: viewedEvent.status,
            VariantId: $('#Variants').val() || '',
            EventId: viewedEvent.id
          };
        }

        configDecisionPane(viewedEvent); // init selectric

        LKCommon.initSelectric($('.event-details .select'));
      });
    });
    $(document).on('click', '.event-list-back', function () {
      var $eventDetailsLoader = $('.event-details').find('.loader.-local');
      var day = {
        //Day: viewedDay.toISOString(),
        Day: viewedDay.toLocaleDateString()
      };

      if (viewedEvent.type === 'Meeting') {
        $('.modal-footer').empty().hide(); // confirm only if submited

        if (isDateChangeAccepted) {
          confirmDescision(descisionObject, function (resp) {
            var passed = resp.Success;

            if (passed) {
              descisionObject = {
                Action: 'New',
                VariantId: '',
                EventId: null
              };
              viewedEvent = null;
              isDateChangeAccepted = false;
              selectedDate = null;
              $eventDetailsLoader.show();
              getDayEvents(day, function (template) {
                $('.modal-title').html("\u0421\u043E\u0431\u044B\u0442\u0438\u044F \u043D\u0430 ".concat(viewedDay.toLocaleDateString()));
                $('.modal-body').html(template);
                $eventDetailsLoader.hide();
              });
            } else {
              console.error(resp.Result);
            }
          });
        } else {
          descisionObject = {
            Action: 'New',
            VariantId: '',
            EventId: null
          };
          viewedEvent = null;
          isDateChangeAccepted = false;
          $eventDetailsLoader.show();
          getDayEvents(day, function (template) {
            $('.modal-title').html("\u0421\u043E\u0431\u044B\u0442\u0438\u044F \u043D\u0430 ".concat(viewedDay.toLocaleDateString()));
            $('.modal-body').html(template);
            $eventDetailsLoader.hide();
          });
        }
      } else {
        $eventDetailsLoader.show();
        getDayEvents(day, function (template) {
          $('.modal-title').html("\u0421\u043E\u0431\u044B\u0442\u0438\u044F \u043D\u0430 ".concat(viewedDay.toLocaleDateString()));
          $('.modal-body').html(template);
          $eventDetailsLoader.hide();
        });
      }
    });
    $(document).on('click', '.event-invitation-action', function () {
      var paneOptions = {};

      if (viewedEvent.status === 'New') {
        paneOptions = {
          type: 'buttons',
          buttons: [{
            title: 'Принять',
            classes: '-primary -big -wide event-invitation-accepted'
          }, {
            title: 'Отклонить',
            classes: '-secondary -big -wide event-invitation-rejected'
          }]
        }; // reset decisionObject

        descisionObject = {
          Action: 'New',
          VariantId: '',
          EventId: null
        }; // юзер еще может передумать

        isDateChangeAccepted = false;
      } else {
        // событие не новое и у нас уже есть решение человека по нему
        if (descisionObject.Action === 'Accepted' || descisionObject.Action === 'AcceptedAlter') {
          // change pane to rejected decision
          paneOptions = {
            type: 'pane',
            pane: {
              text: 'Приглашение отклонено',
              action: {
                title: 'Изменить решение'
              }
            }
          };
          descisionObject.Action = 'Rejected';
        } else if (descisionObject.Action === 'Rejected') {
          // change pane to accepted decision
          paneOptions = {
            type: 'pane',
            pane: {
              text: 'Приглашение принято',
              action: {
                title: 'Изменить решение'
              }
            }
          };
          descisionObject.Action = descisionObject.VariantId === '' ? 'Accepted' : 'AcceptedAlter';
        } // сохраняем решение, т.к. юзер его изменил


        isDateChangeAccepted = true;
      }

      renderDecisionPane(paneOptions);
    });
    $(document).on('click', '.event-invitation-accepted', function () {
      var paneOptions = {
        type: 'pane',
        pane: {
          text: 'Приглашение принято',
          action: {
            title: 'Изменить решение'
          }
        }
      };
      descisionObject.Action = descisionObject.VariantId === '' ? 'Accepted' : 'AcceptedAlter';
      descisionObject.EventId = viewedEvent.id;
      renderDecisionPane(paneOptions); // set date change acceptance status

      isDateChangeAccepted = true;
    });
    $(document).on('click', '.event-invitation-rejected', function () {
      var paneOptions = {
        type: 'pane',
        pane: {
          text: 'Приглашение отклонено',
          action: {
            title: 'Изменить решение'
          }
        }
      };
      descisionObject.Action = 'Rejected';
      descisionObject.EventId = viewedEvent.id;
      renderDecisionPane(paneOptions); // set date change acceptance status

      isDateChangeAccepted = true;
    });
    $(document).on('click', '.event-details-date-change', function () {
      var $eventDateSelect = $('#Variants');

      if ($eventDateSelect.data('selectric').state.opened) {
        $eventDateSelect.selectric('close');
      } else {
        $eventDateSelect.selectric('open');
      }
    });
    $(document).on('mouseenter', '.eventItem', function () {
      var $body = $('body');
      var $this = $(this);
      var title = $this.attr('data-title');
      var offset = $this.offset();
      var height = $this.outerHeight();
      var width = $this.outerWidth();
      $body.append("<div class=\"event-popup\">".concat(title, "</div>"));
      var $eventPopup = $('.event-popup');
      var popupWidth = $eventPopup.outerWidth();
      var popupHeight = $eventPopup.outerHeight();
      $eventPopup.css({
        top: "".concat(offset.top - height - popupHeight / 2, "px"),
        left: "".concat(offset.left - (popupWidth - width) / 2, "px")
      });
    });
    $(document).on('mouseleave', '.eventItem', function () {
      $('.event-popup').remove();
    });
  }

  function init(calendarParams) {
    unbindHandlers();
    setParams(calendarParams);
    bindHandlers();
  }

  return {
    init: init,
    renderAgenda: renderAgenda,
    renderAgendaEvents: renderAgendaEvents,
    openEventCardById: openEventCardById,
    openDayEventsModal: openDayEventsModal,
    isInited: false,
    unbindHandlers: unbindHandlers
  };
}();